import Vue from 'vue'

const moment = require('moment')
require(`moment/locale/he`)

Vue.use(require('vue-moment'), {
  moment
})
